import config from 'Cloud/config';

export const ON_PREMISE_WHITELIST_DOMAINS: string[] | false = config.get('ON_PREMISE_WHITELIST_DOMAINS');
export const WHITELIST_DOMAINS = ['mail.ru', 'inbox.ru', 'list.ru', 'corp.mail.ru', 'bk.ru', 'mail.ua', 'inbox.ua', 'list.ua', 'bk.ua'];

if (config.get('DEV_SERVER')) {
    WHITELIST_DOMAINS.push('devmail.ru');
    WHITELIST_DOMAINS.push('mini-mail.ru');
}
